module.exports = __webpack_public_path__ + "img/patient-card-tabs-mobile-fr.64779414.jpg";